import { useSelector } from 'react-redux';
import { RootState } from '../../../config/redux/types';
import { BOOKING_CONFIRMATION } from '../../../routes/config/pageTypes';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import BookingConfirmation from '../components/BookingConfirmation';

export default function BookingConfirmationContainer(): JSX.Element | null {
  const { bookingConfirmation } = useSelector((state: RootState) => state.routes);

  useLegacyApi(undefined, BOOKING_CONFIRMATION);

  if (!bookingConfirmation) {
    return null;
  }

  return <BookingConfirmation {...bookingConfirmation} />;
}
